import { faCheck, faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n from "../../../../constants/i18n";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import { TPasswordRuleChecks } from "../../../../helpers/et3-password-policy";
import {
  PASSWORD_RULE_FONT_SIZE,
  PASSWORD_RULE_GAP,
  PASSWORD_RULE_ICON_SIZE,
  PASSWORD_RULES_BACKGROUND,
  PASSWORD_RULES_GAP,
  PASSWORD_RULES_PADDING,
  PASSWORD_RULES_RADIUS,
  PASSWORD_RULES_TITLE_FONT_SIZE,
  PASSWORD_TRANSITION
} from "../change-password-constants";

const Requirement = withLiteObserverAndTheme<{
  label: string;
  isMet: boolean;
}>((props) => {
  const { label, isMet, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: PASSWORD_RULE_GAP * unitX
      }}
      onClick={() => {}}
    >
      <FontAwesomeIcon
        icon={isMet ? faCheck : faCircle}
        color={isMet ? colors.all.green : colors.all.lightGray}
        style={{
          width: PASSWORD_RULE_ICON_SIZE * unitX,
          height: PASSWORD_RULE_ICON_SIZE * unitY,
          flexShrink: 0,
          transition: PASSWORD_TRANSITION
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={PASSWORD_RULE_FONT_SIZE}
        text={label}
        isSpan={false}
        color={isMet ? colors.all.maastrichtBlue : colors.all.davysGrey}
        style={{
          margin: 0,
          textAlign: "left",
          transition: PASSWORD_TRANSITION
        }}
      />
    </ET3Div>
  );
});

const PasswordRequirements = withLiteObserverAndTheme<{
  checks: TPasswordRuleChecks;
  isDifferentFromOldPassword: boolean;
  isMatching: boolean;
}>((props) => {
  const { checks, isDifferentFromOldPassword, isMatching, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={PASSWORD_RULES_BACKGROUND}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        borderRadius: PASSWORD_RULES_RADIUS * unitX,
        padding: PASSWORD_RULES_PADDING * unitX,
        gap: PASSWORD_RULES_GAP * unitY
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={PASSWORD_RULES_TITLE_FONT_SIZE}
        text={i18n.get("PASSWORD_REQUIREMENTS")}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0, textAlign: "left" }}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_LENGTH")}
        isMet={checks.hasValidLength}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_UPPERCASE")}
        isMet={checks.hasUppercase}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_LOWERCASE")}
        isMet={checks.hasLowercase}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_NUMBER")}
        isMet={checks.hasDigit}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_SYMBOL")}
        isMet={checks.hasSymbol}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_NO_ARABIC_OR_SPACES")}
        isMet={checks.hasNoArabic && checks.hasNoWhitespace}
      />
      <Requirement
        label={i18n.get("PASSWORD_RULE_DIFFERENT_FROM_OLD")}
        isMet={isDifferentFromOldPassword}
      />
      <Requirement label={i18n.get("PASSWORD_RULE_MATCH")} isMet={isMatching} />
    </ET3Div>
  );
});
export default PasswordRequirements;
